// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qj-9";
export var arrowButtonContainer = "_qj-5";
export var arrowButtonIcon = "_qj-6";
export var carouselArrowButton = "_qj-2";
export var carouselElementContainer = "_qj-1";
export var currentSlide = "_qj-8";
export var left = "_qj-3";
export var otherSlide = "_qj-a";
export var productCarouselContainer = "_qj-0";
export var right = "_qj-4";
export var sliderOverflow = "_qj-7";